// extracted by mini-css-extract-plugin
export default {"relevanceScoreButtonContainer":"ZupR2Z_PkAGsqLKxGVBE__relevanceScoreButtonContainer___","newRelevanceScoreButton":"xsUyhbobMwUsStuc9XiA__newRelevanceScoreButton___"};